<template>
  <gj-dropdown :placement="placement">
    <gj-button
        v-bind="$attrs"
        v-on="$listeners"
        :type="type"
        :plain="mapPlain">
      <slot></slot><i class="el-icon-arrow-down el-icon--right"></i>
    </gj-button>
    <template #dropdown>
      <slot name="dropdown"></slot>
    </template>
  </gj-dropdown>
</template>

<script>
  export default {
    name: "gj-dropdown-button",
    props: {
      type: {
        type: String,
        default: 'default',
      },
      placement: {
        type: String,
        default: 'bottom-start'
      },
      plain: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      mapPlain() {
        return this.type !== 'primary' && this.plain;
      }
    }
  }
</script>

<style scoped>

</style>
